import { render } from "./YouTube.vue?vue&type=template&id=7f9d066a&scoped=true"
import script from "./YouTube.vue?vue&type=script&lang=js"
export * from "./YouTube.vue?vue&type=script&lang=js"

import "./YouTube.vue?vue&type=style&index=0&id=7f9d066a&scoped=true&lang=css"

import exportComponent from "D:\\케이터링\\html(JW 가상화서버)\\justinfood\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9d066a"]])

export default __exports__